import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaCadenaComponent } from "app/features/componentes/firmacadena";

type Entity = models.ViajeEADDto;
type EntityCliente = models.ClienteDatosCP;
import { columnas } from "./columnsModal";
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}



/**
* Modal de edición para un InformacionCliente
*/
export class CartaPortePorClienteModal extends React.PureComponent<Props> {

    onCerrar = () => {
        this.props.onClose(false);
    }

    onDescargarCartaPorteEAD = async (x: EntityCliente ) => {
        if (await kea.yesno(`¿timbrar carta por del viaje ${x.Folio} ?`)) {

            var xml = await resources.Factura.descargarXmlViajeEadPorCliente(x.IdViajeEad, (x.Idcliente != null ? x.Idcliente : 0));
            kea.download(kea.base64ToBlob(xml, 'application/xml'), "CartaPorteViajeEAD"+ x.Folio + "-"+ x.NombreCliente +".xml");
        }
    }

    onImprimirCartaPorteEAD = async (x: EntityCliente ) => {
        if (await kea.yesno(`¿Imprimir pdf de carta porte del viaje ${x.Folio} ?`)) {
            var PdfCartaPorte = await resources.Factura.ImprimirPdfEadPorCliente(x.IdViajeEad, (x.Idcliente != null ? x.Idcliente : 0));
            kea.download(kea.base64ToBlob(PdfCartaPorte, 'application/pdf'), "CartaPorteViajeEAD"+ x.Folio + "-"+ x.NombreCliente +".pdf");
        }
    }

    render() {
        const value = this.props.value;
        const Titulo = "Listado de cartas porte del viaje "+ value.Folio

        const cols = columnas(this,this.props.value.IdRegistro);
        
        return (
            <kea.Modal
                buttons={[]}
                onClose={this.onCerrar}
                title= { Titulo }
            >
                {
                        <div>
                            <kea.Grid2 columnas={cols} cookieKey={"ViajeEadCpCookieKey"} items={value.ClientesEspecialesCartaPorte} />
                        </div>
                }

            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/list/modal.tsx